import { ContentCardModel } from "atoms/models";
import Card from "./Card";

const FeaturedProducts: React.FC<{ featuredContent: Array<ContentCardModel> }> = ({ featuredContent }) => {
  return (
    <div
      className={
        Array.isArray(featuredContent) && featuredContent.length === 2 ? "featured-cards-container-two-products" : "featured-cards-container"
      }
    >
      {Array.isArray(featuredContent) && featuredContent.length > 0
        ? featuredContent.map((card: any, index: number) => (
            <div className="featured-card" key={index} id={card.bundleDescription ? `bundleId: ${card.id}` : `productId: ${card.id}`}>
              <Card key={card.id} card={card} />
            </div>
          ))
        : null}
    </div>
  );
};
export default FeaturedProducts;
